"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configurationHasEspool = void 0;
function configurationHasEspool(configuration) {
    return Boolean(configuration.espool);
}
exports.configurationHasEspool = configurationHasEspool;
//# sourceMappingURL=ConfigurationWithEspool.js.map